import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var ExcelShortcutSvg = function ExcelShortcutSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#107C41",
    fillRule: "evenodd",
    d: "M2 0h20a2 2 0 0 1 2 2v20a2 2 0 0 1-2 2H8.708A9 9 0 0 0 0 9.223V2a2 2 0 0 1 2-2",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.488 15h3.742v-.945H11.29V8.493h-1.107l-.004 5.749q.171.37.308.758m-3.149-4.246 1.504-2.261H7.664l-1.101 1.748q.402.237.776.513M5.574 9.737l-.79-1.244h-1.35l.468.708c.58.125 1.14.306 1.672.536m14.88 3.535c0 1.021-.986 1.818-2.543 1.818-1.265 0-2.498-.634-2.646-1.89h1.134c.144.657.747 1.013 1.507 1.013.806 0 1.44-.329 1.44-.932 0-.536-.445-.801-1.111-.945l-1.197-.261c-.972-.198-1.566-.765-1.58-1.714-.009-1.18 1.03-1.949 2.421-1.949 1.625 0 2.484.882 2.498 1.935H19.27c-.081-.774-.657-1.044-1.377-1.044-.716 0-1.283.351-1.283.936 0 .423.23.666.995.841l1.17.261c1.453.298 1.678 1.243 1.678 1.931",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.313 23.583q-1.793 0-3.053-1.245T0 19.295q0-1.27.647-2.288a4.36 4.36 0 0 1 1.725-1.57H0V14h5.39v5.39H3.954v-2.97a2.72 2.72 0 0 0-1.797.934 2.8 2.8 0 0 0-.719 1.917q0 1.201.839 2.038a2.78 2.78 0 0 0 2.037.837z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};
export var ExcelShortcut = function ExcelShortcut(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: ExcelShortcutSvg
  }));
};